<template>
<div>
    <country-flag :country="row.country"/>
</div>
</template>

<script>
import Vue from 'vue'
import CountryFlag from 'vue-country-flag'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    components: {
        CountryFlag
    }
})
</script>

<style>

</style>